import { Link } from "react-router-dom";
import { Page, Reveal, MaskedLine, Eyebrow } from "@/components/motion/Reveal";
import CalendlyInline from "@/components/CalendlyInline";

export default function Consultation() {
  return (
    <Page data-testid="consultation-page">
      <section data-testid="consultation-hero" className="bg-ivory pt-40 pb-16">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
          <Eyebrow>Private Consultation</Eyebrow>
          <h1 className="font-serif font-medium tracking-tight text-5xl sm:text-6xl lg:text-7xl text-obsidian mt-8 leading-[1.05]">
            <MaskedLine delay={0.2}>Let's Talk About</MaskedLine>
            <MaskedLine delay={0.35} className="italic text-gold-dark">What's Next.</MaskedLine>
          </h1>
          <Reveal delay={0.5}>
            <p className="text-base sm:text-lg font-light leading-relaxed text-stone-text mt-8 max-w-2xl">
              Whether you're exploring executive coaching or business development
              support, choose a time below and we'll start the conversation. No
              pressure, no pitch, just clarity about your next step.
            </p>
          </Reveal>
        </div>
      </section>

      <section data-testid="consultation-scheduler-section" className="bg-ivory pb-24 lg:pb-36">
        <div className="max-w-5xl mx-auto px-6 sm:px-10 lg:px-16">
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-3 border border-gold/40 translate-x-3 translate-y-3 pointer-events-none" />
              <CalendlyInline />
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 border-t border-obsidian/10 pt-8">
              <p className="text-sm font-light text-stone-text">
                Planning an event instead? Speaking inquiries use a separate form.
              </p>
              <Link
                to="/speaking#inquiry"
                data-testid="consultation-speaking-inquiry-link"
                className="shrink-0 font-mono text-[11px] tracking-[0.25em] uppercase text-gold-dark hover:text-obsidian transition-colors"
              >
                Book Sharon to Speak →
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </Page>
  );
}
